import {RlMediaStream} from "./RlMediaStream";

export class RlVideoStream extends RlMediaStream {

    public get Width(): number {
        return this.Stream.getVideoTracks()[0].getSettings().width | 0;
    }

    public get Height(): number {
        return this.Stream.getVideoTracks()[0].getSettings().height | 0;
    }

    public get Framerate(): number {
        return this.Stream.getVideoTracks()[0].getSettings().frameRate | -1;
    }

    public get AspectRatio(): number {
        return this.Stream.getVideoTracks()[0].getSettings().aspectRatio | 0;
    }


    public PlayOnVideoElement(video: HTMLVideoElement){
        video.srcObject = this.Stream;
        video.autoplay = true;
        video.playsInline = true;
    }

}